<div class="py-3">
  <form [formGroup]="buttonsForm">

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{'pass.name' | translate}}</mat-label>
      <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}" data-nar="buttons-widget-name">
    </mat-form-field>

    <mat-tab-group class="button-source-tabs" [selectedIndex]="isDataStructureMode ? 1 : 0" (selectedIndexChange)="selectButtonSource($event)"
      data-nar="buttons-widget-source-tabs">
      <mat-tab [disabled]="isArrayMode" label="{{ 'pass.widgets.manualSource' | translate }}">
        <div class="my-3">
          <button mat-button class="secondary-gray-button" (click)="addButton();" [disabled]="translationModeOriginal || data.translateMode">
            <mat-icon>add_circle</mat-icon> {{'pass.buttons.add_button' | translate}}
          </button>
        </div>
        <div>
      <form [formGroup]="allbuttonsForm">
        <mat-accordion multi>

          @for ( button of allButtons; track  button; let index = $index) {
            <mat-expansion-panel class="mt-1 mb-1" (opened)="panelOpenState = true"
              (closed)="panelOpenState = false" [expanded]="index === 0" data-nar="buttons-widget-buttons-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>{{allbuttonsForm.value[button.id+'.title'] ? allbuttonsForm.value[button.id+'.title'] : 'pass.buttons.button.button' | translate }} {{index + 1}} </mat-panel-title>
                <button mat-icon-button style="color: red;" (click)="deleteBtn(index, button.id);" [disabled]="translationModeOriginal || data.translateMode" [style.color]="(translationModeOriginal || data.translateMode) ? '#b8b8b8' : 'red'">
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </mat-expansion-panel-header>
              <div class="w-100">
                <mat-form-field appearance="outline" class="w-100 mb-1">
                  <mat-label>{{'pass.title' | translate}}</mat-label>
                  <input formControlName="{{button.id}}.title" type="text" matInput placeholder="{{'pass.title' | translate}}" data-nar="buttons-widget-title">
                </mat-form-field>
                <div class="w-100 d-flex flex-row mb-3 pb-3">
                  <mat-form-field appearance="outline" class="w-100 link-field">
                    <mat-label>{{ 'pass.url' | translate }}</mat-label>
                    <!-- CHIP PREFIX -->
                    @if (getLinkChip(button); as chip) {
                      <mat-chip-set matPrefix class="link-chip-prefix">
                        <mat-chip-row (removed)="clearLinkChip(button)">
                          <div class="d-flex align-items-center">
                            <mat-icon class="material-symbols-outlined chip-icon">
                              {{ chip.kind === 'child' ? 'link' : 'anchor' }}
                            </mat-icon>
                            <span class="chip-text">{{ chip.label }}</span>
                            <button matChipRemove type="button" aria-label="Remove" [disabled]="translationModeOriginal">
                              <mat-icon class="material-symbols-outlined">close</mat-icon>
                            </button>
                          </div>
                        </mat-chip-row>
                      </mat-chip-set>
                    }
                    <input
                      matInput
                      [formControlName]="button.id + '.url'"
                      type="text"
                      [placeholder]="'pass.url' | translate"
                      [readonly]="!!getLinkChip(button)"
                      [class.input-hidden]="!!getLinkChip(button)"
                      data-nar="buttons-widget-link" />
                    <button
                      mat-icon-button
                      matSuffix
                      [matMenuTriggerFor]="linkMenu"
                      [matMenuTriggerData]="{ button: button }"
                      matTooltip="{{ 'pick_link_target' | translate }}"
                      type="button"
                      [disabled]="translationModeOriginal">
                      <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
                    </button>
                    @if (allbuttonsForm.controls[button.id + '.url']?.hasError('invalidCharacters')) {
                      <mat-error>
                        {{ 'invalid_characters' | translate }}
                      </mat-error>
                    }
                    @if (!allbuttonsForm.controls[button.id + '.url']?.hasError('invalidCharacters')
                      && allbuttonsForm.controls[button.id + '.url']?.invalid) {
                      <mat-error >
                        {{ 'url_pattern_invalid' | translate }}
                      </mat-error>
                    }
                    <mat-hint>{{ 'url_pattern_detailed' | translate }}</mat-hint>
                  </mat-form-field>
                  <input
                    type="file"
                    style="display: none;"
                    accept=".pdf, .jpg, .png, .jpeg, .doc, .docx, .xls, .xlsx, .txt, .csv, .vcf, .rtf, .webp"
                    (change)="readDocument($event, button)"
                    #fileInput >
                </div>
                <!-- Main menu -->
                <mat-menu #linkMenu="matMenu">
                  <ng-template matMenuContent let-button="button">
                    @if (anchorOptions?.length) {
                      <button mat-menu-item [matMenuTriggerFor]="anchorMenu" [matMenuTriggerData]="{ button: button }" >
                        <mat-icon class="material-symbols-outlined">anchor</mat-icon>
                        <span>{{ 'pass.linkWidgetUrl' | translate }}</span>
                      </button>
                    }
                    @if (childPages?.length) {
                      <button mat-menu-item [matMenuTriggerFor]="childMenu" [matMenuTriggerData]="{ button: button }" >
                        <mat-icon class="material-symbols-outlined">link</mat-icon>
                        <span>{{ 'pass.linkChildPage' | translate }}</span>
                      </button>
                    }
                    <button mat-menu-item (click)="fileInput.click()">
                      <mat-icon class="material-symbols-outlined">folder_open</mat-icon>
                      <span>{{ 'pass.browse' | translate }}</span>
                    </button>
                  </ng-template>
                </mat-menu>
                <!-- Anchors submenu -->
                <mat-menu #anchorMenu="matMenu">
                  <ng-template matMenuContent let-button="button">
                    <button mat-menu-item disabled> {{ 'widgets' | translate }} </button>
                    @for (a of anchorOptions; track a) {
                      <button mat-menu-item (click)="setButtonUrl(button, buildAnchorUrl(a))" >
                        <span>{{ a.label || a.name || a.id }}</span>
                      </button>
                    }
                  </ng-template>
                </mat-menu>
                <!-- Child pages submenu -->
                <mat-menu #childMenu="matMenu">
                  <ng-template matMenuContent let-button="button">
                    <button mat-menu-item disabled> {{ 'pass.pageTabLabels' | translate }} </button>
                    @for (c of childPages; track c) {
                      <button mat-menu-item (click)="setButtonUrl(button, buildChildPageUrl(c))" >
                        <span>{{ c.name || c.id }}</span>
                      </button>
                    }
                  </ng-template>
                </mat-menu>
                <div class="form-control p-3 mb-3 d-flex justify-content-between w-100">
                  <label for="value">{{'pass.buttons.button.customize' | translate}}</label>
                  <mat-slide-toggle class="ms-5 example-margin" formControlName="{{button.id}}.customize"></mat-slide-toggle>
                </div>
                @if (getCustomizeOptionOfButton(index, button.id);) {
                  <div>
                    <mat-tab-group>
                      <mat-tab label="{{'pass.lightTheme' | translate}}">
                        <div class="list-group mb-4 ">
                          <div class="list-group-item">
                            <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                              <span class=" w-50 bg-white">{{'pass.buttons.backgroundColor' | translate}}</span>
                              <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;">
                                <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="{{button.id}}.backgroundColor" style="margin-left:10px;" data-nar="buttons-widget-light-background-color"></ngx-colors>
                                @if (allbuttonsForm.controls[button.id + '.backgroundColor']?.hasError('invalidColor')) {
                                  <span id="invalid_accent" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                                }
                              </label>
                            </div>
                          </div>
                          <div class="list-group-item">
                            <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                              <span class="w-50 bg-white">{{'pass.buttons.borderColor' | translate}}</span>
                              <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                                <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="{{button.id}}.borderColor" style="margin-left:10px;" data-nar="buttons-widget-light-border-color"></ngx-colors>
                                @if (allbuttonsForm.controls[button.id + '.borderColor']?.hasError('invalidColor')) {
                                  <span id="invalid_title" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                                }
                              </label>
                            </div>
                          </div>
                          <div class="list-group-item">
                            <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                              <span class="w-50 bg-white">{{'pass.buttons.foregroundColor' | translate}}</span>
                              <div class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                                <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="{{button.id}}.foregroundColor" style="margin-left:10px;" data-nar="buttons-widget-light-foreground-color"></ngx-colors>
                                @if (allbuttonsForm.controls[button.id + '.foregroundColor']?.hasError('invalidColor')) {
                                  <span id="invalid_subtitle" style="color:red;" data-nar="buttons-widget-light-foreground-color">{{'pass.invalid_color' | translate}}</span>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </mat-tab>
                      <mat-tab label="{{'pass.darkTheme' | translate}}">
                        <div class="list-group mb-4 " data-nar="buttons-widget-dark-colors-tab">
                          <div class="list-group-item">
                            <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                              <span class=" w-50 bg-white" >{{'pass.buttons.backgroundColor' | translate}}</span>
                              <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                                <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="{{button.id}}.backgroundColorDark" style="margin-left:10px;" data-nar="buttons-widget-dark-background-color"></ngx-colors>
                                @if (allbuttonsForm.controls[button.id + '.backgroundColorDark']?.hasError('invalidColor')) {
                                  <span id="invalid_accent" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                                }
                              </label>
                            </div>
                          </div>
                          <div class="list-group-item">
                            <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                              <span class="w-50 bg-white" >{{'pass.buttons.borderColor' | translate}}</span>
                              <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                                <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="{{button.id}}.borderColorDark" style="margin-left:10px;" data-nar="buttons-widget-dark-border-color"></ngx-colors>
                                @if (allbuttonsForm.controls[button.id + '.borderColorDark']?.hasError('invalidColor')) {
                                  <span id="invalid_title" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                                }
                              </label>
                            </div>
                          </div>
                          <div class="list-group-item">
                            <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                              <span class="w-50 bg-white" >{{'pass.buttons.foregroundColor' | translate}}</span>
                              <div class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                                <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="{{button.id}}.foregroundColorDark" style="margin-left:10px;" data-nar="buttons-widget-dark-foreground-color"></ngx-colors>
                                @if (allbuttonsForm.controls[button.id + '.foregroundColorDark']?.hasError('invalidColor')) {
                                  <span id="invalid_subtitle" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </mat-tab>
                    </mat-tab-group>
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{'pass.buttons.borderWidth' | translate}}</mat-label>
                      <input formControlName="{{button.id}}.borderWidth" type="number" matInput placeholder="{{'pass.buttons.borderWidth' | translate}}" data-nar="buttons-widget-borderwidth">
                      <span matSuffix class="p-3"> px</span>
                    </mat-form-field>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </form>
    </div>
      </mat-tab>

      <mat-tab label="{{ 'pass.widgets.dataStructureSource' | translate }}">
      <div class="button-source-content pt-3">
      <p class="text-muted mb-3">{{ 'pass.widgets.repeatButtonsHelp' | translate }}</p>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'pass.widgets.arrayKeyPath' | translate }}</mat-label>
        <input formControlName="keyPath" type="text" matInput data-nar="buttons-widget-key-path">
        @if (arrayKeyPaths.length && !data.translateMode) {
          <button mat-icon-button matSuffix type="button" [matMenuTriggerFor]="arrayPathMenu"
            [attr.aria-label]="'pass.widgets.chooseArrayPath' | translate">
            <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
          </button>
        }
        <mat-hint>{{ 'pass.widgets.arrayKeyPathHint' | translate }}</mat-hint>
      </mat-form-field>
      <mat-menu #arrayPathMenu="matMenu">
        @for (path of arrayKeyPaths; track path) {
          <button mat-menu-item type="button" style="width: 320px; max-width: 100%;" [matTooltip]="path"
            [attr.aria-label]="path" (click)="selectArrayKeyPath(path)">
            <span class="d-block text-truncate">{{ displayArrayKeyPath(path) }}</span>
          </button>
        }
      </mat-menu>

      @if (isArrayMode && dynamicButton) {
        <div class="mt-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'pass.title' | translate }}</mat-label>
            <input matInput type="text" [formControl]="getDynamicButtonFieldControl('title')"
              (input)="setDynamicButtonField('title', $any($event.target).value)"
              placeholder="name" data-nar="buttons-widget-dynamic-title">
            @if (arrayItemKeyPaths.length) {
              <button mat-icon-button matSuffix type="button" [matMenuTriggerFor]="dynamicButtonTitleMenu">
                <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
              </button>
            }
            <mat-hint>{{ 'pass.widgets.arrayItemKeyPathHint' | translate }}</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'pass.url' | translate }}</mat-label>
            <input matInput type="text" [formControl]="getDynamicButtonFieldControl('url')"
              (input)="setDynamicButtonField('url', $any($event.target).value)"
              placeholder="url" data-nar="buttons-widget-dynamic-url">
            @if (arrayItemKeyPaths.length) {
              <button mat-icon-button matSuffix type="button" [matMenuTriggerFor]="dynamicButtonUrlMenu">
                <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
              </button>
            }
            <mat-hint>{{ 'pass.widgets.arrayItemKeyPathHint' | translate }}</mat-hint>
          </mat-form-field>

          <mat-menu #dynamicButtonTitleMenu="matMenu">
            @for (path of arrayItemKeyPaths; track path) {
              <button mat-menu-item type="button" [matTooltip]="path" (click)="setDynamicButtonField('title', path)">
                <span class="d-block text-truncate">{{path}}</span>
              </button>
            }
          </mat-menu>
          <mat-menu #dynamicButtonUrlMenu="matMenu">
            @for (path of arrayItemKeyPaths; track path) {
              <button mat-menu-item type="button" [matTooltip]="path" (click)="setDynamicButtonField('url', path)">
                <span class="d-block text-truncate">{{path}}</span>
              </button>
            }
          </mat-menu>
        </div>
      }
      </div>
      </mat-tab>
    </mat-tab-group>

    <div class="text-muted text-uppercase my-4">{{'pass.buttons.defaultStyle' | translate }}</div>
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section">

      <form [formGroup]="buttonsStyleForm">

        <mat-tab-group>
          <mat-tab label="{{'pass.lightTheme' | translate}}">
            <div class="list-group mb-4">
              <div class="list-group-item">
                <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                  <span class=" w-50 bg-white" >{{'pass.buttons.backgroundColor' | translate}}</span>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="backgroundColor" style="margin-left:10px;" data-nar="buttons-widget-light-background-color-general"></ngx-colors>
                    @if (buttonsStyleForm.controls['backgroundColor'].hasError('invalidColor')) {
                      <span id="invalid_accent" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </div>
              <div class="list-group-item">
                <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                  <span class="w-50 bg-white" >{{'pass.buttons.borderColor' | translate}}</span>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="borderColor" style="margin-left:10px;" data-nar="buttons-widget-light-border-color-general"></ngx-colors>
                    @if (buttonsStyleForm.controls['borderColor'].hasError('invalidColor')) {
                      <span id="invalid_title" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </div>
              <div class="list-group-item">
                <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                  <span class="w-50 bg-white" >{{'pass.buttons.foregroundColor' | translate}}</span>
                  <div class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="foregroundColor" style="margin-left:10px;" data-nar="buttons-widget-light-foreground-color-general"></ngx-colors>
                    @if (buttonsStyleForm.controls['foregroundColor'].hasError('invalidColor')) {
                      <span id="invalid_subtitle" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="{{'pass.darkTheme' | translate}}">
            <div class="list-group mb-4">
              <div class="list-group-item">
                <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                  <span class=" w-50 bg-white" >{{'pass.buttons.backgroundColor' | translate}}</span>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="backgroundColorDark" style="margin-left:10px;" data-nar="buttons-widget-dark-background-color-general"></ngx-colors>
                    @if (buttonsStyleForm.controls['backgroundColorDark'].hasError('invalidColor')) {
                      <span id="invalid_accent" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </div>
              <div class="list-group-item">
                <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                  <span class="w-50 bg-white" >{{'pass.buttons.borderColor' | translate}}</span>
                  <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="borderColorDark" style="margin-left:10px;" data-nar="buttons-widget-dark-border-color-general"></ngx-colors>
                    @if (buttonsStyleForm.controls['borderColorDark'].hasError('invalidColor')) {
                      <span id="invalid_title" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </label>
                </div>
              </div>
              <div class="list-group-item">
                <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                  <span class="w-50 bg-white" >{{'pass.buttons.foregroundColor' | translate}}</span>
                  <div class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                    <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="foregroundColorDark" style="margin-left:10px;" data-nar="buttons-widget-dark-foreground-color-general"></ngx-colors>
                    @if (buttonsStyleForm.controls['foregroundColorDark'].hasError('invalidColor')) {
                      <span id="invalid_subtitle" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

        </mat-tab-group>


        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.buttons.borderWidth' | translate}}</mat-label>
          <input formControlName="borderWidth" type="number" matInput min="0" placeholder="{{'pass.buttons.borderWidth' | translate}}" data-nar="buttons-widget-borderwidth-general">
          <span matSuffix class="p-3"> px</span>
        </mat-form-field>
      </form>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.buttons.cornerRadius' | translate}}</mat-label>
        <input formControlName="cornerRadius" type="number"  min="0" matInput placeholder="{{'pass.buttons.cornerRadius' | translate}}">
        <span matSuffix class="p-3"> px</span>
      </mat-form-field>

    </section>
  </form>
  <div [app-widget-styling] = "{'form':buttonsForm.value, 'widgetData': data}" (returnChanges)="returnChangesStyle($event)" class="my-1" ></div>

  <div [app-widget-edit-filters] = "{'form':buttonsForm.value, 'widgetData': data}" (returnChanges)="returnChangesFilters($event)"></div>
</div>
